import { markRaw } from 'vue';
import { siteWrapper, siteWrapperWidth } from './../core/dom.js';
import { apiCall, apiGet, apiDelete, apiPost, apiPut } from '../core/apiCalls.js';
import {
    disposeProjectCandidatesScopeStore,
    persistCurrentFiltersToStorage,
} from '@js/stores/projectCandidatesStore.js';
import { getAllRegisteredStores } from '@js/piniaStoreRegistry.js';
import {
    isProjectModal,
    resolveNextProjectCandidatesDepth,
} from '@js/stores/helpers/projectCandidatesScopeHelpers.js';

export default {
    data() {
        return {
            nal: window.nal,
            moment,
        };
    },
    inject: ['toClipboard'],
    computed: {
        siteWrapperWidth() {
            return siteWrapperWidth.value;
        },
        siteWrapper() {
            return siteWrapper.value;
        },
    },
    methods: {
        async copyToClipboard(text, successMessage) {
            try {
                await this.toClipboard(text);
                notify(successMessage, 'success');
            } catch (error) {
                notify(error.message, 'alert');
            }
        },
        trans(...args) {
            return window.trans(...args);
        },
        trans_choice(...args) {
            return window.trans_choice(...args);
        },
        optional(...args) {
            return window.optional(...args);
        },
        call(method, url, data = null, options = {}) {
            return apiCall(method, url, data, options);
        },
        get(url, data, options) {
            return apiGet(url, data, options);
        },
        delete(url, data) {
            return apiDelete(url, data);
        },
        post(url, data, options) {
            return apiPost(url, data, options);
        },
        put(url, data, options) {
            return apiPut(url, data, options);
        },
        auth(...args) {
            return window.auth(...args);
        },
        closeCurrentModal() {
            if (this.nal.modal.backtrace.length) {
                this.nal.modal.isBacktrace = true;
                this.createModal({ data: this.nal.modal.backtrace.pop(), isBacktrace: false });

                const _isProjectModal = isProjectModal(this.nal.modal.data);

                if (_isProjectModal) {
                    persistCurrentFiltersToStorage(resolveNextProjectCandidatesDepth(this.nal.modal.data, {
                        isProjectType: _isProjectModal,
                    }));
                }
                return;
            }

            this.closeAllModals();
        },
        closeAllModals() {
            this.disposeModalStores();

            this.nal.modal.backtrace = [];
            this.nal.modal.showModal = false;
            this.nal.modal.data = null;
        },
        disposeModalStores() {
            // Dispose all modal-scoped projectCandidates stores.
            const projectCandidatesStores = getAllRegisteredStores(/^projectCandidates_/);

            projectCandidatesStores.forEach(store => {
                disposeProjectCandidatesScopeStore({ storeId: store.$id, force: true });
            });
        },
        handleModalBacktrace() {
            if (!this.nal.modal.isBacktrace) {
                if (this.nal.modal.showModal) {
                    // Omit backtrace property, otherwise end up with endless nesting of backtraces
                    let oldModal = _.omit(this.nal.modal, 'backtrace');
                    oldModal.isBacktrace = true;
                    this.nal.modal.backtrace.push(oldModal);
                }
            }
        },
        setModalComponent(data) {
            if (_.isObject(data.component)) {
                let componentNameIsComponent = false;
                let componentName;

                if (data.component.name && data.component.name === 'component') {
                    componentNameIsComponent = true;
                    componentName = 'modal-' + (new Date).getTime();
                }

                if (componentNameIsComponent) {
                    this.nal.modal.component = componentName;
                } else {
                    this.nal.modal.component = markRaw(data.component);
                }
            } else {
                this.nal.modal.component = data.component;
            }
        },
        setModalData(data) {
            this.nal.modal.data = data.data || {};
            this.nal.modal.style = data.style || {};
            this.nal.modal.colorClass = data.colorClass || 'u-primary-color';
            this.nal.modal.hasNoPadding = data.hasNoPadding || false;
            this.nal.modal.document = data.document || false;
            this.nal.modal.on = data.on || {};
            this.nal.modal.isBacktrace = false;
            this.nal.modal.blur = _(data).has('blur') ? data.blur : true;
            this.nal.modal.showModal = true;
            this.nal.modal.scrollTop = data.scrollTop ?? undefined;
            if (data.key) {
                this.nal.modal.key = data.key;
            } else {
                this.nal.modal.key = 'unique' + this.nal.modal.uniqueId;
                this.nal.modal.uniqueId++;
            }
        },
        getModalPayloadForScopeDepth(modalConfig) {
            if (modalConfig?.data?.isBacktrace === true) {
                return null;
            }

            const modalPayload = modalConfig?.data;
            if (!_.isObject(modalPayload) || !_.isObject(modalPayload.data)) {
                return null;
            }

            const existingDepth = Number(modalPayload.data.projectCandidatesScopeDepth);
            if (Number.isInteger(existingDepth) && existingDepth >= 1) {
                return null;
            }

            return modalPayload;
        },
        initializeProjectCandidatesScopeDepth(modalConfig) {
            const modalPayload = this.getModalPayloadForScopeDepth(modalConfig);
            if (!modalPayload) {
                return;
            }

            const nextDepth = resolveNextProjectCandidatesDepth(this.nal?.modal?.data, {
                isProjectType: isProjectModal(modalPayload),
            });

            if (nextDepth !== null) {
                modalPayload.data.projectCandidatesScopeDepth = nextDepth;
            }
        },
        createModal(data) {
            this.initializeProjectCandidatesScopeDepth(data);
            this.handleModalBacktrace(data.data);
            this.setModalComponent(data.data);
            this.setModalData(data.data);
        },
    },
};
